
import {Vue, Component, Prop, Watch, VModel} from "vue-property-decorator";

@Component({})
export default class SelectPackage extends Vue {
    @Prop({
        default: () => {
            []
        }
    })
    public packages!: object[];

    @VModel()
    public currentPackage!: object;
    public selectedPackage: object = {
        'text': 'Select a package',
        'id': 0,
    };

    @Watch('currentPackage')
    private onPacketChange() {
        this.packages.forEach((el) => {
            if (el.text === this.currentPackage) {
                this.selectedPackage = el;  //whole object bc arr of obj
            }
        })
    }

    public onChange(change: string) {
        this.$emit("change", change);
    }
}
